import * as React from "react";
import * as Markdown from 'react-markdown'
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useCookies } from "react-cookie";
import { Buffer2Base64 } from "../../misc/Helpers/ArrayHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompress, faExpand } from '@fortawesome/free-solid-svg-icons';

export const WelcomeWidget = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const cookieNamePrefix = 'WpCollapseWelcomeMessage_'
    const [cookieName, setCookieName] = React.useState<string>(cookieNamePrefix + study.id);
    const [cookies, setCookies] = useCookies([cookieName]);
    const [message, setMessage] = React.useState<string>(null);
    const [collapsed, setCollapsed] = React.useState(false);

    const getSHA256 = async (msg: string) => {
        return Buffer2Base64(await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(msg)));
    }

    React.useEffect(() => {
        const checkCookieForLastReadMessage = async () => {
            setCookieName(cookieNamePrefix + study.id);
            setMessage(study.welcomeMessage);

            const latestMessageDigest = await getSHA256(study.welcomeMessage);
            setCollapsed(study.welcomeMessage && cookies[cookieName].collapse === true && cookies[cookieName].messageDigest == latestMessageDigest);
        }

        checkCookieForLastReadMessage();
    }, [study]);



    const minimize = async () => {
        const collapse = !collapsed;
        const oneYearFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

        const messageDigest = await getSHA256(study.welcomeMessage);

        setCookies(cookieName, { collapse, messageDigest }, { path: '/', expires: oneYearFromNow });
        setCollapsed(collapse);
    }

    if (!message) {
        return null;
    }

    return (<div className="col-xs-12">
        <div id="WelcomeWidget" className="ibox">
            <div className="ibox-title">
                <h5 className="text-primary">Study Information</h5>
                <div>
                    <span data-automationid="Pull-right-button" className="pull-right">
                        <FontAwesomeIcon className="text-primary" icon={collapsed ? faExpand : faCompress} style={{ cursor: "pointer" }} onClick={minimize} />
                    </span>
                </div>
            </div>
            {collapsed
                ? null
                : <div data-automationid="WelcomeMessageContent" className="ibox-content">
                    <Markdown>{message}</Markdown>
                </div>
            }
        </div>
    </div>);
}
